import { SLUGS } from '../../../enum/permissions.enum';

export const ESTIMATE_MENU = {
  materials: [
    { check: SLUGS.PROJECT.MATERIAL.READ, to: '/material', primary: 'Список материалов', add: true },
    { check: SLUGS.PROJECT.WORK.READ, to: '/work', primary: 'Список работ', add: true },
    { check: SLUGS.PROJECT.ESTIMATE.READ, to: '/estimate', primary: 'Смета' },
  ],
  journals: [
    { check: SLUGS.PROJECT.JOURNAL.READ, to: '/journal_cables', primary: 'Кабельные журналы', add: true },
  ]
};
export const ESTIMATE_SECTIONS = {
  materials: 'Списки',
  journals: 'Журналы'
};

export const DOCUMENT_MENU = {
  certificates: [
    { check: SLUGS.PROJECT.CERTIFICATES.READ, to: '/certificates', primary: 'Список ', add: true },
  ],
  documents: [
    { check: SLUGS.PROJECT.SHIPMENT.MATERIAL.READ, to: '/shipment/materials', primary: 'Покупка материалов', add: true },
    { check: SLUGS.PROJECT.SHIPMENT.RECEIPT.READ, to: '/receipt/materials', primary: 'Получение давальческих материалов', add: true },
    { check: SLUGS.PROJECT.SHIPMENT.RECEIPT.READ, to: '/shipment/order', primary: 'Заказать давальческие материалы' },
  ],
  rent: [
    { check: SLUGS.PROJECT.SHIPMENT.EQUIPMENT.READ, to: '/shipment/equipment', primary: 'Покупка оборудования', add: true },
    { check: SLUGS.PROJECT.SHIPMENT.RENT.READ, to: '/shipment/rent', primary: 'Аренда оборудования', add: true },
    { check: SLUGS.DOC.CAR_RENTAL.READ, to: '/shipment/carrental', primary: 'Аренда техники', add: true },
    { check: SLUGS.PROJECT.SHIPMENT.RENT.READ, to: '/shipment/rent/list', primary: 'Оборудование на балансе' },
  ],
  acceptance: [
    { check: SLUGS.PROJECT.DELIVERY.READ, to: '/acceptance', primary: 'Акты приемки' },
    { check: SLUGS.PROJECT.DELIVERY.DOC, to: '/delivery/doc', primary: 'Оприходование материалов' },
    { check: SLUGS.PROJECT.INPUT_CONTROL.READ, to: '/input-control', primary: 'Журнал входного контроля' },
    { check: SLUGS.PROJECT.DELIVERY.DOC, to: '/delivery/material', primary: 'Материалы к поставке' },
  ],
  orders: [
    { check: SLUGS.PROJECT.ORDER.READ_FEED, to: '/orders/lenta', primary: 'Лента заказов' },
    { check: SLUGS.PROJECT.ORDER.UPDATE_FEED, to: '/orders/process', primary: 'Обработка заказов' },
  ],
  ocr: [
    { check: SLUGS.PROJECT.OCR_ENTERA, to: '/ocr/doc', primary: 'Документы' },
    { check: SLUGS.PROJECT.OCR_ENTERA, to: '/ocr/recognition', primary: 'Распознать' },
    { check: SLUGS.PROJECT.OCR_ENTERA, to: '/ocr/tack', primary: 'Задачи распознавания' },
  ],
  order: [
    { check: SLUGS.DOC.MAT_ORDER_P.READ, to: '/order/provider', primary: 'Документы', add: true },
    { check: SLUGS.DOC.MAT_ORDER_P.READ, to: '/order/provider/summary', primary: 'Сводная таблица' },
  ]
}
export const DOCUMENT_SECTIONS = {
  orders: 'Обработка заказов',
  order: 'Заказ поставщику',
  documents: 'Закупка',
  rent: 'Оборудование и техника',
  acceptance: 'Поступление товаров',
  ocr: 'Распознавание документов',
  certificates: 'Сертификаты на материалы',
}

export const PRODUCTION_MENU = {
  orders: [
    { check: SLUGS.PROJECT.ORDER.PRODUCTION, to: '/orders/my', primary: 'Мои заказы', add: true },
  ],
  task: [
    { check: SLUGS.PROJECT.GRANT.READ, to: '/form/gant', primary: 'Диаграмма ганта' },
    { check: SLUGS.PROJECT.GRANT.READ, to: '/form/gant/price', primary: 'Кассовый план' },
    { check: SLUGS.PROJECT.CALENDAR.READ, to: '/form/schedule', primary: 'График работ' },
    { check: SLUGS.PROJECT.CALENDAR.READ, to: '/calendar', primary: 'Календарь' },
  ],
  machine: [
    { check: SLUGS.PROJECT.CALENDAR_MACHINE.READ, to: '/machine-calendar', primary: 'Календарь техники' },
    { check: SLUGS.PROJECT.CALENDAR_MACHINE.READ, to: '/machine-list', primary: 'Список техники' },
    { check: SLUGS.PROJECT.CALENDAR_MACHINE.READ, to: '/machine-workplace', primary: 'Рабочее место' },
    { check: SLUGS.PROJECT.WAYBILL.READ, to: '/waybill', primary: 'Путевые листы' },
  ],
  outfit: [
    { check: SLUGS.PROJECT.OUTFIT.PLAN_READ, to: '/outfit/plan', primary: 'Наряд заказ план', add: true },
    { check: SLUGS.PROJECT.OUTFIT.FACT_READ, to: '/outfit/fact', primary: 'Наряд заказ факт' },
    { check: SLUGS.PROJECT.OUTFIT.FACT_READ, to: '/outfit/fact/day', primary: 'Факт день' },
    { check: SLUGS.PROJECT.OUTFIT.FACT_READ, to: '/outfit/planfact/day', primary: 'План/Факт день' },

  ],
  worker: [
    { check: SLUGS.PROJECT.WORKER.READ, to: '/worker', primary: 'Список', add: true },
    { check: SLUGS.PROJECT.TEAM.READ, to: '/team', primary: 'Бригады', add: true },
    { check: SLUGS.PROJECT.WORKER.MANAGE, to: '/worker/attent', primary: 'Присутствие' },
    { check: SLUGS.PROJECT.WORKER.READ, to: '/worker/resources', primary: 'Доступные ресурсы' },
    { check: SLUGS.PROJECT.ANALYTICS.WORKER, to: '/analytics/worker', primary: 'Отчёт по присутствию' },
  ],
  tool: [
    { check: SLUGS.PROJECT.TOOL_UW.USE_READ, to: '/usetool/transfer', primary: 'Выдача оборудования', add: true },
    { check: SLUGS.PROJECT.TOOL_UW.WRITE_READ, to: '/usetool/acceptance', primary: 'Приемка оборудования', add: true },
    { check: SLUGS.STORAGE.INVENTORY.READ, to: '/storage/inventory', primary: 'Список' },
  ],
  formKs2: [
    { check: SLUGS.PROJECT.FROM_KS.READ, to: '/form/ks2', primary: 'КС2', add: true },
    { check: SLUGS.PROJECT.FROM_KS.READ, to: '/form/ks2/table', primary: 'КС2 Сводная таблица' },
  ],
  actRD: [
    { check: SLUGS.DOC.INSP_HID_W.READ, to: '/act/ihw', primary: 'Акт скрытых работ', add: true },
  ],
  remarks: [
    { check: SLUGS.PROJECT.REMARK.READ, to: '/remarks', primary: 'Замечания', add: true },
  ],
  welding: [
    { check: SLUGS.PROJECT.OUTFIT.FACT_READ, to: '/zhor', primary: 'Общий журнал работ' },
    { check: SLUGS.PROJECT.WELDING.READ, to: '/welding', primary: 'Журнал сварочных работ' },
  ]
}
export const PRODUCTION_SECTION = {
  task: 'Планирование работ',
  machine: 'Техника',
  outfit: 'Наряд на работу',
  orders: 'Заказ материалов',
  worker: 'Работники',
  tool: 'Инструменты',
  welding: 'Журналы работ',
  formKs2: 'Акты о приемке работ',
  actRD: 'Акты РД',
  remarks: 'Замечания',
}
export const STORAGE_MENU = {
  materials: [
    { check: SLUGS.PROJECT.STORAGE.READ, to: '/storage/materials', primary: 'Остатки на складе' },
    { check: SLUGS.PROJECT.STORAGE.READ, to: '/storage/materials/dynamics', primary: 'Динамика' },
    { check: SLUGS.DOC.REMOVAL_P.READ, to: '/storage/materials/removal', primary: 'Документы списания', add: true },
    { check: SLUGS.PROJECT.STORAGE.MOVE_READ, to: '/storage/materials/move', primary: 'Переместить на главный склад', add: true },
  ],
  inventory: [
    { check: SLUGS.STORAGE.INVENTORY.READ, to: '/storage/inventory', primary: 'Список' },
    { check: SLUGS.STORAGE.INVENTORY.MOVE_READ, to: '/storage/inventory/removal', primary: 'Переместить на склад', add: true },
  ],
}
export const STORAGE_SECTION = {
  materials: 'Сметные материалы',
  inventory: 'Инвентарные объекты',
}
export const ANALYTIC_MENU = {
  main: [
    { check: SLUGS.PROJECT.ANALYTICS.PROJECT, to: '/analytics/project', primary: 'Проект' },
    { check: SLUGS.PROJECT.ANALYTICS.MATERIAL, to: '/analytics/material', primary: 'Материалы' },
  ]
}
export const ANALYTIC_SECTION = {
  main: 'Аналитика'
}

export const ALL_MENUS = {
  estimate: ESTIMATE_MENU,
  document: DOCUMENT_MENU,
  production: PRODUCTION_MENU,
  storage: STORAGE_MENU,
  analytics: ANALYTIC_MENU,
};